/* eslint-disable new-cap */
import React from "react";
import jsPDF from "jspdf";
import { Editor } from "primereact/editor";
import PageWrapper from "../../../../PageWrapper";
import PrimaryButton from "../../../../SFUCentralThemedComponents/PrimaryButton";
import Label from "../../../../Label";

import ProgressSpinnerPR from "../../../../PrimeReact/ProgressSpinnerPR";

export default function AnswersPage({
  goToPage,
  pageInfo,
  scholarshipAppData,
  steppers,
  spinnerStatus,
}) {
  const questionsObjArr = Object.entries(scholarshipAppData.data.questions);
  const questions2 = [];
  questionsObjArr.forEach(([, value]) => {
    questions2.push(value);
  });

  const contactMethodName = `fieldValue_${scholarshipAppData.data.fields.contactMethod.scholarship_application_fields_id}`;
  const contactMethodInputName = `fieldValue_${scholarshipAppData.data.fields.contactMethodInput.scholarship_application_fields_id}`;

  const getMarginalizedGroups = () => {
    let marginalizedGroups = [];

    questions2.map((questions) =>
      questions.map((question) =>
        question.header.includes("Self Identification Survey") &&
        scholarshipAppData.data[
          `questionAnswer_${question.scholarship_application_answers_id}`
        ] === "1"
          ? marginalizedGroups.push(question.question)
          : ""
      )
    );

    if (marginalizedGroups.length === 0) {
      marginalizedGroups = ["None selected"];
    }

    return marginalizedGroups;
  };

  const docs = () => {
    if (!scholarshipAppData.data.docs) {
      return "";
    }
    let docNum = 0;
    return scholarshipAppData.data.docs.map((doc) => {
      const formattedDoc = (
        <>
          <div key={doc.scholarship_application_docs_id} className="p-grid">
            <div className="p-col-12">
              <h3>Letter of Support {(docNum += 1)}</h3>
              <span>File name: {doc.display_file_name}</span>
            </div>
            <div className="p-col-12">
              <Label>
                <span>
                  Please describe why you chose this document (50 words max)
                </span>
              </Label>
              <div className="p-grid">
                <div className="p-col-12 p-md-6">
                  <Editor
                    key={`docNote_${doc.scholarship_application_docs_id}`}
                    value={
                      scholarshipAppData.data[
                        `docNote_${doc.scholarship_application_docs_id}`
                      ]
                    }
                    readOnly
                    headerTemplate={<span />}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      );
      return formattedDoc;
    });
  };

  const ref = React.createRef();

  const handleDownloadPdf = () => {
    const doc = new jsPDF();

    doc.fromHTML(ref.current.innerHTML, 15, 10, {
      width: 170,
    });

    doc.save("Review.pdf");
  };

  return (
    <PageWrapper>
      {steppers(pageInfo.pageNum)}
      <div className="p-grid">
        <div className="p-col-12">
          <h1>Application Review</h1>
        </div>

        <div className="p-col-12">
          <p style={{ marginBottom: "0" }}>
            Please navigate using back the BACK button at the bottom of the page
            to make changes to your responses.
          </p>
        </div>

        <div ref={ref}>
          <div className="p-col-12">
            <h3>Questions</h3>
            {questions2.map((questions, index) => (
              <>
                {questions.map((question) =>
                  question.header.includes("Self Identification Survey") ||
                  (question.question.includes("parent(s)/guardian(s)") &&
                    scholarshipAppData.data[
                      `questionAnswer_${question.scholarship_application_answers_id}`
                    ] === "0") ? (
                    ""
                  ) : (
                    <div className="p-grid review-questions-container">
                      <div
                        key={`questionAnswer_${question.scholarship_application_answers_id}`}
                        className="p-col-12"
                      >
                        <p>
                          {(question.question.includes("Family") ||
                            question.question.includes(
                              "list the birth year of each dependent"
                            ) ||
                            question.question.includes("how many dependents") ||
                            question.question.includes("parent(s)/guardian(s)")) &&
                          scholarshipAppData.data[
                            `questionAnswer_${question.scholarship_application_answers_id}`
                          ] !==
                            "I am a Youth in Care, or a former Youth in Care" ? (
                            <>
                              <b>
                                {index + 1}-{question.order}.
                              </b>{" "}
                              {question.question}{" "}
                            </>
                          ) : (
                            <>
                              <b>{index + 1}.</b> {question.question}{" "}
                            </>
                          )}
                          {question.word_limit && question.word_limit > 0
                            ? ` (${question.word_limit} words max)`
                            : ""}
                        </p>

                        <Editor
                          value={
                            scholarshipAppData.data[
                              `questionAnswer_${question.scholarship_application_answers_id}`
                            ]
                          }
                          readOnly
                          headerTemplate={<span />}
                        />
                      </div>
                    </div>
                  )
                )}
              </>
            ))}
          </div>

          <div className="p-col-12 p-md-6">
            <h3>Self Identification Survey</h3>
            {getMarginalizedGroups().map((marginalizedGroup) => (
              <>
                <Editor
                  value={marginalizedGroup}
                  readOnly
                  headerTemplate={<span />}
                />
              </>
            ))}
          </div>

          <div className="p-col-12">{docs()}</div>

          <div className="p-col-12 p-md-6">
            <h3>Contact Method</h3>
            <p>
              {/* <InputText
                value={`${scholarshipAppData.data[contactMethodName]} - ${scholarshipAppData.data[contactMethodInputName]}`}
              /> */}
              <Editor
                value={`${scholarshipAppData.data[contactMethodName]} - ${scholarshipAppData.data[contactMethodInputName]}`}
                readOnly
                headerTemplate={<span />}
              />
            </p>
          </div>
        </div>
        <div className="p-col-12">
          <PrimaryButton
            type="button"
            onClick={handleDownloadPdf}
            className="small"
          >
            Download Application Details
          </PrimaryButton>
        </div>
      </div>

      <div className="button-navigation-container">
        <PrimaryButton
          type="button"
          onClick={() => {
            goToPage(pageInfo.pageNum - 1);
          }}
        >
          Back
        </PrimaryButton>
        <PrimaryButton
          type="button"
          className="push-right"
          onClick={() => {
            goToPage(pageInfo.pageNum + 1);
          }}
        >
          Next
        </PrimaryButton>
      </div>
      {spinnerStatus ? <ProgressSpinnerPR /> : ""}
    </PageWrapper>
  );
}
